export default __webpack_public_path__ + "static/media/Savage Death Boots.ae375d51.jpg";